import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    RecodeVariableCommand,
    IVariablesClient,
    VariablesClient,
    EditDisplayLabelsCommand,
} from "app/ApiClient";
import { LoadingState, checkAndThrowInstructionValidationException } from "types";
import {initialRecodeState} from "./recodeState";

const variableClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);
export const recodeVariable = createAsyncThunk(
    "recode/recodeVariable",
    async (command: RecodeVariableCommand, {rejectWithValue}) => {
        try {
            const result = await variableClient.recodeVariable(command);
            checkAndThrowInstructionValidationException(result);
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);

export const editVariablesDisplayLabels = createAsyncThunk(
    "recode/editDisplayLabels",
    async (command: EditDisplayLabelsCommand, { rejectWithValue }) => {
        try {
            const result = await variableClient.editDisplayLabels(command);
            checkAndThrowInstructionValidationException(result);
            return result;
        } catch (error) {
            return rejectWithValue(error);
        }
    },
);

const recodeSlice = createSlice({
    name: "recode",
    initialState: initialRecodeState,
    reducers: {
        resetRecode: (state) => {
            state.recoding = LoadingState.idle;
            state.recodedError = null;
        },
        resetEditBatchState: (state) => {
            state.editingBatch = LoadingState.idle;
            state.editedBatchResult = null;
            state.editedBatchError = null;
        }
    },
    extraReducers: (builder) => {
        // recodeVariable
        builder.addCase(recodeVariable.pending, (state) => {
            state.recoding = LoadingState.pending;
            state.recodedError = null;
        });
        builder.addCase(recodeVariable.fulfilled, (state) => {
            state.recoding = LoadingState.succeed;
            state.recodedError = null;
        });
        builder.addCase(recodeVariable.rejected, (state, {error}) => {
            state.recoding = LoadingState.failed;
            state.recodedError = error.message;
        });

        // editVariables
        builder.addCase(editVariablesDisplayLabels.pending, (state) => {
            state.editingBatch = LoadingState.pending;
            state.editedBatchResult = null;
            state.editedBatchError = null;
        });
        builder.addCase(editVariablesDisplayLabels.fulfilled, (state, { payload }) => {
            state.editingBatch = LoadingState.succeed;
            state.editedBatchResult = payload;
            state.editedBatchError = null;
        });
        builder.addCase(editVariablesDisplayLabels.rejected, (state, { error }) => {
            state.editingBatch = LoadingState.failed;
            state.editedBatchError = error.message;
        });
    },
});
export const {resetRecode, resetEditBatchState} = recodeSlice.actions;
export default recodeSlice.reducer;
